<template>
  <div class="kontakt">
    <!-- HEADER
		================================================== -->
    <section class="section section_header section_header__contacts">
      <div class="container">
        <div class="row">
          <div class="col-sm-12">
            <!-- Heading -->
            <h1 class="section__heading section_header__heading text-center">
              Kontakt
            </h1>
          </div>
        </div>
        <!-- .row -->
      </div>
      <!-- .container -->
      <div class="section_header__bg contacts_bg"></div>
    </section>

    <!-- section contacts -->
    <section class="section_contacts">
      <div class="container">
        <div class="row">
          <div class="col-sm-12">
            <h2 class="section_title">Kontaktieren Sie uns</h2>
            <hr class="section_title_line" />
          </div>
        </div>

        <div class="row">
          <div class="col-sm-4 col-sm-offset-4">
            <div class="section_contacts__item">
              <!-- Title -->
              <h3 class="item__title">
                Telefon
              </h3>
              <i class="ion-ios-telephone-outline"></i>

              <!-- Content -->
              <p class="item__content">
                <a href="tel:+49 4941 63344">04941 63344</a>
              </p>
              <p class="item__content">
                <a href="tel:+49 4941 64945">04941 64945</a>
              </p>
            </div>
          </div>
        </div>
        <!-- / .row -->
      </div>
      <!-- .container -->
    </section>

    <!-- section map-heading -->
    <section class="section_map-heading" id="section_contacts">
      <div class="container">
        <!-- / .row -->
        <div class="row">
          <div class="col-sm-12">
            <h2 class="map__title">Kommen Sie vorbei</h2>
            <p class="map__address">Am Pferdemarkt 7, 26603 Aurich</p>
          </div>
        </div>
        <!-- .row -->
      </div>
      <!-- .container -->
    </section>

    <!-- section map -->
    <div class="section_map">
      <div class="section_row">
        <div id="map">
          <iframe
            v-if="showGoogleMaps"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2374.712773404779!2d7.480545951846416!3d53.47359317277469!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47b6425b2db8b023%3A0x3502e7aed0747a37!2sDafni!5e0!3m2!1sde!2sde!4v1597758701365!5m2!1sde!2sde"
            width="100%"
            height="100%"
            frameborder="0"
            style="border:0;"
            allowfullscreen=""
            aria-hidden="false"
            tabindex="0"
          ></iframe>
          <div class="activate_google-maps" v-else @click="loadGoogleMaps">
            <div>Google Maps anzeigen</div>
          </div>
        </div>
      </div>
      <!-- / .section_row -->
    </div>
    <!-- / .section_map -->
  </div>
</template>

<script>
export default {
  name: "Kontakt",
  metaInfo: {
    title: "Kontakt - Restaurant Dafni Aurich"
  },
  data: () => ({
    showGoogleMaps: false
  }),
  methods: {
    loadGoogleMaps() {
      this.showGoogleMaps = true;
    }
  }
};
</script>

<style>
.section_map #map {
  margin: 0;
  height: 45vh;
}

.activate_google-maps {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  cursor: pointer;
}

.activate_google-maps div {
  border: 2px solid #1b2d2f;
  color: #000000;
  border-radius: 5px;
  padding: 10px 20px;
}
</style>
